export default __webpack_public_path__ + "static/media/Q02_焦糖、可可、鳳梨果乾、煙燻甘草香氣.24a37139.mp4";